import {
    ChangeDetectionStrategy,
    Component, DestroyRef,
    EventEmitter, inject,
    Input,
    OnInit,
    Output, ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import {Consumer} from '@emm/core/models/consumer.model';
import {LocationSet} from '@emm/core/models/location-set.model';
import {Observable} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {MenuSearchComponent} from '@emm/menu/components/menu-search/menu-search.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-menu-key-header',
    styleUrls: ['./menu-key-header.component.scss'],
    templateUrl: './menu-key-header.component.html',
    standalone: false
})
export class MenuKeyHeaderComponent implements OnInit {

    private readonly destroyRef: DestroyRef = inject(DestroyRef);
    @Input() selectedConsumer: Consumer;
    @Input() selectedLocation: LocationSet;
    @Input() selectedFeatureScope: string;
    @Input() selectedEffectiveDate: Observable<string>;
    @Input() contentLoading = true;
    @Input() isSuperAdmin: boolean;
    @Input() isAdmin: boolean;

    @Output() add = new EventEmitter();
    @Output() collapse = new EventEmitter();
    @Output() searchButtonClicked = new EventEmitter<string>();
    @Output() clearSearchButtonClicked = new EventEmitter<void>();

    @ViewChild(MenuSearchComponent) menuSearch: MenuSearchComponent;

    today = new Date();
    isDateToday = false;
    constructor() {}

    ngOnInit(): void {
        this.selectedEffectiveDate.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((date) => {
            this.isDateToday = new Date(date).getDate() === this.today.getDate();
        });
    }

    handleSearchButtonClicked(filter: string) {
        this.searchButtonClicked.next(filter);
    }

    handleClearSearchButtonClicked() {
        this.menuSearch.searchFilter = '';
        this.clearSearchButtonClicked.next();
    }
}
